import type {
  ExternalDropdownOption,
  InternalDropdownOption,
} from '~/chords/DropdownSingleSelect/types';

export interface GetExternalToInternalOptionsResult {
  internalOptions: InternalDropdownOption[];
  selectedOption?: InternalDropdownOption;
}

/**
 * Transforms external dropdown options into internal dropdown options.
 * @param externalOptions - The external dropdown options to transform.
 * @param param1.selectedValue - The currently selected value.
 * @returns The transformed internal dropdown options.
 */
export function updateExternalToInternal(
  externalOptions: ExternalDropdownOption[],
  { selectedValue }: { selectedValue?: string },
): GetExternalToInternalOptionsResult {
  let selectedOption: InternalDropdownOption | undefined;

  const internalOptions = externalOptions.map((option, optionIndex) => {
    const isSelected = option.value === selectedValue;

    const internalOption: InternalDropdownOption = {
      ...option,
      // Augment external option with default internal values.
      isSelected,
      isVisible: true,
      optionIndex,
    };

    if (isSelected) {
      selectedOption = internalOption;
    }

    return internalOption;
  });

  return { internalOptions, selectedOption };
}
